import * as React from 'react';
import ParticipantRow from './Row';
import { observer } from 'mobx-react';
import { ParticipantImportFileRow } from '../../Store/Types';

interface Props {
  participants: ParticipantImportFileRow[];
}

const Body: React.FC<Props> = ({ participants }) => (
  <tbody className="divide-y divide-gray-200 bg-white">
    {participants.map((participant) => (
      <ParticipantRow participant={participant} key={participant.email} />
    ))}
  </tbody>
);

export default observer(Body);
